// this is a wrapper to avoid using new everywhere, and to bundle the css
// could also implement site-wide defaults here

import Flickity from 'flickity'
import 'flickity/css/flickity.css'
import {initImage} from './project'

export function flickity (el, options) {
  // return

  const defaults = {
    dragThreshold: 30,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: 4000 + Math.random() * 2000, // avoid simultaneous transition
    wrapAround: true
  }
  return new Flickity(el, Object.assign(defaults, options))
}

export function initCarousel (el, options, minCells = 2) {
  const carousel = el.querySelector('.carousel')
  // const controls = el.querySelector('.carousel-controls')

  if (carousel.children.length < minCells) {
    return
  }

  Array(...carousel.querySelectorAll('.image')).forEach(initImage)

  const flkty = flickity(carousel, Object.assign({
    // defaults here
  }, options))

  // if (controls) {
  //   flickityCounter(flkty, controls.querySelector('.counter'))
  //
  //   controls.querySelector('.next').addEventListener('click', (e) => {
  //     flkty.next(true)
  //     e.preventDefault()
  //   })
  //   controls.querySelector('.previous').addEventListener('click', (e) => {
  //     flkty.previous()
  //     e.preventDefault()
  //   })
  //   controls.classList.add('active')
  //
  //   flkty.on('select', () => {
  //     const advanced = flkty.selectedIndex > 0
  //     controls.classList[advanced ? 'add' : 'remove']('advanced')
  //   })
  // }

  return flkty
}

// export function flickityCounter (flkty, el, sep = '/') {
//   const updateCounter = () => {
//     var slideNumber = flkty.selectedIndex + 1
//     el.innerHTML = '<span>' + slideNumber + '</span>' + sep + '<span>' + flkty.slides.length + '</span>'
//   }
//   updateCounter()
//   flkty.on('select', updateCounter)
// }

// export function initCarousel (el, options, minCells = 2) {
//   const carousel = el.querySelector('.carousel')
//   const controls = el.querySelector('.carousel-controls')
//
//   if (carousel.children.length < minCells) {
//     return
//   }
//
//   const flkty = flickity(carousel, Object.assign({
//     prevNextButtons: false,
//     pageDots: true,
//     // autoPlay: 1500,
//     autoPlay: carousel.getAttribute('data-auto') ? 7500 : null,
//     wrapAround: true
//   }, options))
//
//   if (controls) {
//     flickityCounter(flkty, controls.querySelector('.counter'))
//
//     controls.querySelector('.next').addEventListener('click', (e) => {
//       flkty.next(true)
//       e.preventDefault()
//     })
//     controls.querySelector('.previous').addEventListener('click', (e) => {
//       flkty.previous()
//       e.preventDefault()
//     })
//     controls.classList.add('active')
//
//     flkty.on('select', () => {
//       const advanced = flkty.selectedIndex > 0
//       controls.classList[advanced ? 'add' : 'remove']('advanced')
//     })
//   }
//
//   return flkty
// }

// /**
//  * initialises a carousel for an element which displays conditionally
//  * @param  {HTMLElement} el   parent el, must contain a .mobile-carousel child
//  * @param  {Object} options   flickity option overrides
//  * @return {Object}           scrollresize handler object
//  */
// export function initConditionalCarousel (el, options = {}, isEnabled) {
//   const carousel = el.querySelector('.mobile-carousel')
//   const children = carousel.children.length
//
//   let flkty
//   const resize = (ww, wh) => {
//     const enabled = isEnabled(children, ww)
//     if (enabled && !flkty) {
//       flkty = flickity(carousel, Object.assign({
//         prevNextButtons: false,
//         pageDots: true,
//         autoPlay: 7500,
//         wrapAround: true
//       }, options))
//     } else if (!enabled && flkty) {
//       flkty.destroy()
//       flkty = null
//     }
//   }
//
//   return {
//     resize: resize,
//     scroll: () => {}
//   }
// }



// WEBPACK FOOTER //
// ./assets/j/src/flickity.js